if (!customElements.get('product-review')) {
  class ProductReview extends HTMLElement {
    constructor() {
      super();
      this.wrapper = document.querySelector('[data-products-reviews]');
      this.apiKey = this.wrapper.dataset.apiKey;
      this.storeId = this.wrapper.dataset.storeId;

      this.product_rating = document.querySelectorAll('#product_rating');
      this.reviews_number = document.querySelectorAll('#reviews_number');
      this.rating_number = document.querySelectorAll('#rating_number');

      if (this.product_rating) {
        this.product_rating.forEach(async (element) => {
          const productSku = element.dataset.productSku;

          if (productSku) {
            const skuApiUrl = `https://api.reviews.io/product/rating-batch?store=${this.storeId}&sku=${productSku}&apikey=${this.apiKey}`;

            try {
              const response = await fetch(skuApiUrl, {
                method: 'GET',
                headers: { accept: 'application/json' },
              });

              const data = await response.json();
              data.forEach((item) => {
                const rating = item.average_rating || 0;
                element.innerHTML = generateStarRating(rating);
              });
            } catch (error) {
              console.error('Error fetching product ratings:', error);
            }
          }
        });
      }

      const options = { method: 'GET', headers: { accept: 'application/json' } };
      fetch(`https://api.reviews.io/stats/all?store=${this.storeId}`, options)
        .then((response) => response.json())
        .then((response) => {
          const rating = Number(response.product_review_stats.average_rating);
          this.reviews_number.forEach((element) => {
            element.innerText = response.product_review_stats.total_reviews;
          });
          this.rating_number.forEach((element) => {
            element.innerText = rating.toFixed(1);
          });
        })
        .catch((err) => console.error(err));

      function generateStarRating(rating) {
        const roundedRating = Math.round(rating);
        let starsHTML = '';
        new Array(5).fill(null).forEach((_, index) => {
          starsHTML += index + 1 <= roundedRating ? '★ ' : '☆ ';
        });
        return starsHTML;
      }
    }
  }

  window.ProductReview = ProductReview;
  customElements.define('product-review', ProductReview);
}
